module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#shortform",
      toString: function () {
        return this.url;
      }
    }